import React, { useMemo } from 'react';
import world from '../../assets/world-land.json';

const W = 1000;
const PX = W / 360;
const TOP_LAT = 85;
const BOT_LAT = -58;
const H = Math.round((TOP_LAT - BOT_LAT) * PX);

const px = (lng) => (lng + 180) * PX;
const py = (lat) => (TOP_LAT - lat) * PX;

const ringToPath = (ring) =>
  'M' + ring.map(([lng, lat]) => `${px(lng).toFixed(1)},${py(lat).toFixed(1)}`).join('L') + 'Z';

export const OfficeWorldMap = ({ offices, active, onSelect }) => {
  const landPath = useMemo(() => {
    const paths = [];
    world.features.forEach((f) => {
      const g = f.geometry;
      const polys = g.type === 'Polygon' ? [g.coordinates] : g.coordinates;
      polys.forEach((poly) => poly.forEach((ring) => paths.push(ringToPath(ring))));
    });
    return paths.join(' ');
  }, []);

  return (
    <div className="relative rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent overflow-hidden" data-testid="office-world-map">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto block" role="img" aria-label="Hipro global offices map">
        <path d={landPath} fill="#1e293b" stroke="#334155" strokeWidth="0.5" />
        {offices.map((o) => {
          const x = px(o.lng);
          const y = py(o.lat);
          const isActive = active && active.label === o.label;
          return (
            <g
              key={`${o.country}-${o.label}`}
              transform={`translate(${x},${y})`}
              onClick={() => onSelect(o)}
              className="cursor-pointer"
              data-testid={`map-pin-${o.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <circle r="11" fill="#f97316" opacity="0.35" className="office-pin-ping" />
              <circle r={isActive ? 6.5 : 4.5} fill={isActive ? '#fb923c' : '#f97316'} stroke="#0f172a" strokeWidth="1.5" style={{ filter: 'drop-shadow(0 0 6px rgba(249,115,22,0.9))', transition: 'r 0.2s' }} />
              {isActive && <circle r="10" fill="none" stroke="#fb923c" strokeWidth="1.2" opacity="0.9" />}
              <circle r="16" fill="transparent" />
            </g>
          );
        })}
      </svg>

      {active && (
        <div
          className="hidden sm:block absolute z-10 pointer-events-none"
          style={{
            left: `clamp(110px, ${(px(active.lng) / W) * 100}%, calc(100% - 110px))`,
            top: `${(py(active.lat) / H) * 100}%`,
            transform: 'translate(-50%, calc(-100% - 16px))',
          }}
        >
          <div className="w-52 rounded-xl border border-orange-400/40 bg-slate-900/95 backdrop-blur px-3.5 py-3 shadow-xl shadow-black/40" data-testid="map-tooltip">
            <div className="text-xs font-bold text-white">{active.label}</div>
            <div className="text-[10px] font-semibold uppercase tracking-wider text-orange-400">{active.country}</div>
            <div className="mt-1 text-[10px] text-slate-400 leading-relaxed line-clamp-3">{active.address}</div>
          </div>
          <div className="mx-auto h-2 w-2 rotate-45 -mt-1 bg-slate-900/95 border-r border-b border-orange-400/40" />
        </div>
      )}
    </div>
  );
};

export default OfficeWorldMap;
